import gql from 'graphql-tag';

export const getMergedQuestionnaire = gql`query getMergedQuestionnaire(
    $subjectId: String!,
    $key: String!,
    $version: Int,
  ) {
    mergedQuestionnaireForm(
      subjectId: $subjectId,
      questionnaireKey: $key,
      version : $version
    ) {
      mergedForm {
        questionnaire {
          key
        }
        entries {
          question {
            key
          }
          givenAnswers {
            key
            openAnswer
            openAnswerObject
          }
        }
      }
    }
  }`;

export const CHA2DS2VASC = gql`query CHA2DS2VASC(
    $patientId: Int!,
    $age: Int,
    $gender: String,
    $hasCongestiveHeartFailure: Boolean,
    $hasHistoryHypertension: Boolean,
    $hasHistoryDiabetes: Boolean,
    $hasThromboembolism: Boolean,
    $hasHistoryTIA: Boolean,
    $hasHistoryStroke: Boolean,
    $hasStenosisInCoronaryArteries: Boolean,
  ) {
    CHA2DS2VASC(
        patientId: $patientId,
        age: $age,
        gender: $gender,
        hasCongestiveHeartFailure: $hasCongestiveHeartFailure,
        hasHistoryHypertension: $hasHistoryHypertension,
        hasHistoryDiabetes: $hasHistoryDiabetes,
        hasThromboembolism: $hasThromboembolism,
        hasHistoryTIA: $hasHistoryTIA,
        hasHistoryStroke: $hasHistoryStroke,
        hasStenosisInCoronaryArteries: $hasStenosisInCoronaryArteries,
    ) {
           score
      }
  }`
;
